module.exports = __webpack_public_path__ + "img/NIZHEG.ce763883.png";